<template>
  <div class="bind-device-item-bd ub-f1 ubv">
    <div class="ub" style="margin-bottom: 24px">
      <el-button type="warning" style="margin-right: 6px" @click="onBindEvent" v-if="permission.add">
        <i class="icon icon-tianjia"></i>
        <span>&ensp;{{ $t('com_add_to') }}</span>
      </el-button>
      <el-button style="margin-right: 16px" :disabled="!tableSelect.length" @click="onUnbindEvent" v-if="permission.del">
        <i class="icon icon-shanchu"></i>
        <span>&ensp;{{ $t('bind_device_item_yi_chu') }}</span>
      </el-button>
      <div class="ub-f2" style="margin-right: 12px">
        <search-input width="100%" :placeholder="$t('bind_device_item_gsxmmc')" v-model="formSearch.searchName" @fetch="onPageChange({ page: 1 })"></search-input>
      </div>
      <div class="ub-f3">
        <search-input width="100%" :placeholder="$t('bind_device_item_ji_shen_hao')" v-model="formSearch.search" @fetch="onPageChange({ page: 1 })"></search-input>
      </div>
    </div>
    <div class="table-bd ub-f1">
      <custom-table height="100%" stripe type="checkbox" tableCode="portal_organ_device" v-model="tableSelect" :data="tableList"></custom-table>
    </div>
    <div class="table-page">
      <custom-pagination :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-pagination>
    </div>
    <!-- 分配设备 -->
    <bind-device-dialog v-if="dialogVisible" :model="dialogModel" @close="dialogVisible = false" @success="onSuccess()"></bind-device-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import bindDeviceDialog from './bind_device_dialog.vue';

// bind_device_item_yi_chu: 移除// bind_device_item_gsxmmc: 公司/项目名称// bind_device_item_ji_shen_hao: 机身号// bind_device_item_nqdyqxfpyhxzdsbm: 您确定要取消分配用户选中的设备吗？// bind_device_item_nqdyqxfpbmxzdsbm: 您确定要取消分配部门选中的设备吗？// bind_device_item_fen_pei_she_bei: 分配设备

export default {
  name: 'bind_device_item',
  components: { bindDeviceDialog },
  props: {
    permission: {
      type: Object,
      default() {
        return {};
      },
    },
    organ: {
      type: Object,
      default() {
        return {};
      },
    },
    user: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      dialogVisible: false,
      dialogModel: {},
      formSearch: {
        searchName: '',
        bizId: '',
        bizType: '',
        isAss: 1, // 已关联
        parentId: '',
        search: '',
        orderBy: '',
        orderType: '',
        pageSize: 50,
        pageNum: 1,
        productCode: '',
        orgType: '',
        orgName: '',
        projectName: '',
        contractNo: '',
      },
      tableSelect: [],
      tableList: [],
      totalRows: 0,
    };
  },
  watch: {
    organ: function () {
      this.formSearch = JSON.parse(this.resetFormSearch);
      this.tableList = [];
      this.totalRows = 0;
      this.getDeviceList();
    },
    user: function () {
      this.formSearch = JSON.parse(this.resetFormSearch);
      this.tableList = [];
      this.totalRows = 0;
      this.getDeviceList();
    },
  },
  mounted: function () {
    this.mergeLanguage(null, 'portal_bind_device_item');
    this.resetFormSearch = JSON.stringify(this.formSearch);
    this.getDeviceList();
    this.getFuncView();
  },
  methods: {
    // 获取关联设备
    getDeviceList: function () {
      this.formSearch.bizId = this.user && this.user.bizId ? this.user.bizId : this.organ.bizId;
      this.formSearch.bizType = this.user && this.user.bizId ? this.user.bizType : this.organ.bizType;
      this.$getJSON(apis.DeviceBindAutoDevicePage, this.formSearch).then((res) => {
        const list = res.data.list;
        list.forEach((item) => {
          item.isExists = !!item.isAuto;
        });
        this.tableList = list;
        this.totalRows = res.data.total;
      });
    },
    // 取消关联设备
    onUnbindEvent: function () {
      this.$showConfirm(this.user && this.user.bizId ? this.$t('bind_device_item_nqdyqxfpyhxzdsbm') : this.$t('bind_device_item_nqdyqxfpbmxzdsbm'))
        .then(() => {
          this.cancelDevice();
        })
        .catch(() => {});
    },
    cancelDevice: function () {
      const deviceIds = this.tableSelect.map(t => t.deviceId);
      this.$postJSON(apis.BizDeviceUnbind, {
        bizId: this.user.bizId || this.organ.bizId,
        deviceIds,
      }).then(() => {
        this.$message({
          message: this.$t('com_handle_success'),
          type: 'success',
        });
        this.getDeviceList();
      });
    },
    // 关联设备
    onBindEvent: function () {
      this.dialogModel = {
        title: this.$t('bind_device_item_fen_pei_she_bei'),
        user: this.user,
        organ: this.organ,
      };
      this.dialogVisible = true;
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getDeviceList();
    },
    onSuccess() {
      this.getDeviceList();
    },
  },
};
</script>

<style lang="scss">
@import '@/style/colors.scss';
</style>
